import { useQuery } from '@tanstack/react-query';
import { ApiError, api } from '@/lib/api';

export function useMe() {
	return useQuery({
		queryKey: ['me'],
		queryFn: async () => {
			const { data, response } = await api.GET('/api/v1/me');
			if (!data) throw new ApiError(response.status, '/api/v1/me');
			return data;
		},
	});
}
